/**
 * Links from the desk into Slack (Jeff, 2026-10-23: files stay in Slack, so a click should land
 * there). A Slack list ticket opens its row on the Support Tickets list; a desk ticket opens its
 * thread in #support-tickets. Pure; the workspace address comes from `integrations.slackLinks`.
 */
import { type SlackLinks } from '@lsc/contract';
import { useSyncExternalStore } from 'react';

export function slackUrlFor(t: { legacyRef: string | null; slackThreadTs: string | null }, links: SlackLinks | null | undefined): string | null {
  if (!links) return null;
  const rec = t.legacyRef?.startsWith('slack:') ? t.legacyRef.slice('slack:'.length) : null;
  if (rec && links.listId) return `${links.workspaceUrl}lists/${links.teamId}/${links.listId}?record_id=${encodeURIComponent(rec)}`;
  if (t.slackThreadTs && links.channelId && /^\d+\.\d+$/.test(t.slackThreadTs)) return `${links.workspaceUrl}archives/${links.channelId}/p${t.slackThreadTs.replace('.', '')}`;
  return null;
}

/** Set once by the root when `integrations.slackLinks` answers; a store so cards work without a query client. */
let current: SlackLinks | null = null;
const listeners = new Set<() => void>();

export function setSlackLinks(links: SlackLinks | null): void {
  current = links;
  for (const fn of listeners) fn();
}

export function useSlackLinks(): SlackLinks | null {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn);
      return () => listeners.delete(fn);
    },
    () => current,
    () => current,
  );
}
